module.exports = "<div class=\"responsive-label-inline\"\r\n     ng-if=\"::$ctrl.header\">\r\n  {{ ::$ctrl.header }}\r\n</div>\r\n\r\n<div class=\"responsive-label-inline\"\r\n     ng-if=\"::!$ctrl.header\">\r\n</div>\r\n\r\n<div ng-class=\"[$ctrl.textAlignment]\">\r\n  <ng-transclude />\r\n</div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/grid/table-cell.html
// module id = 1865
// module chunks = 0